import { fetchDataError, fetchFacetsSuccess } from '../reducers';
import getSearchUrl from './getSearchUrl';

/**
* Filters dienen eerst ingeladen te worden, anders kunnen URL parameters niet gematcht worden om actieve data op te halen
*/
export default function fetchFilters() {
	return dispatch => {
		let data = {
			//"nonce": "throwaway",
			'page': 9999,
			'per_page': 18,
		};

		fetch( '/facetsearch/json', {
			method: 'POST',
			body: JSON.stringify( data ),
		} )
			.then( result => result.json() )
			.then( result => {

				if ( result.error ) {
					throw ( result.error );
				}

				dispatch( fetchFacetsSuccess( result.filters ) );
				dispatch( getSearchUrl() );

				return result.filters;
			} )
			.catch( error => {
				dispatch( fetchDataError( error ) );
			} );
	}
}
